import { Controller, Payload } from "../../controller";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch } from "redux";

import { Movimentacao, initialValueState, MovState, MovActions, GroupMovimentacaoBySituacao, FilterMovParams, RowItensMovDetalhe, RowItensMovDetalheFunc } from "./mov.model"
import { TipoMovState } from "../tipoMov/tipomov.model";
import { MeioPagActions } from "../meioPag/meiopg.model";
import { meioPagController } from "../meioPag/meiopg.controll";
import { call, put, takeLatest } from "redux-saga/effects";
import { configController } from "../config/config.controll";
import { ClienteActions } from "../cliente/cliente.model";
import { clienteController } from "../cliente/cliente.controll";
import { Funcionario, FuncionarioActions } from "../funcionario/funcionario.model";
import { funcionarioController } from "../funcionario/funcionario.controll";
import { action } from "typesafe-actions";
import { FornecedorActions } from "../fornecedor/forn.model";
import { fornecedorController } from "../fornecedor/forn.controll";
import { ItemActions } from "../item/item.model";
import { itemController } from "../item/item.controll";
import { ResultDb } from "../../services/db";
import { canalDistController } from "../canalDist/canalDist.controll";
import { tipoMovController } from "../tipoMov/tipomov.controll";
import { CanalDistribuicao, Config, Estoque, Item } from "../../data.types";
import { FiltroReadMovCanal } from "../canalDist/canalDist.model";
import { getNewId } from "../../services/utils";
import { estoqueController } from "../estoque/estoque.controll";



export interface MovViewProps {
    movState: MovState
    movActions: MovActions
    tipoMovState: TipoMovState
    meioPagActions: MeioPagActions
    clienteActions: ClienteActions
    funcionarioActions: FuncionarioActions
    fornecedorActions: FornecedorActions
    itemActions: ItemActions
}


class MovController extends Controller<Movimentacao, MovState, MovActions> {
    constructor() {
        super(initialValueState.row.type, initialValueState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            setGroupMov: `@${this.moduloName}/SET_GROUP_MOV`,
            setFiltro: `@${this.moduloName}/SET_FILTRO`,
            setShowMovItem: `@${this.moduloName}/SET_SHOW_MOV_ITEM`,
            fecharMovsAbertos: `@${this.moduloName}/FECHAR_MOVS_ABERTOS`,
            realoadReadView: `@${this.moduloName}/RELOAD_READ_VIEW`,
            setRowsMovGroup: `@${this.moduloName}/SET_ROWS_MOV_GROUP`,
            newMovVenda: `@${this.moduloName}/NEW_MOV_VENDA`,
            createMovimentacao: `@${this.moduloName}/CREATE_MOVIMENTACAO`,
            readMovItensPeriodo: `@${this.moduloName}/READ_MOV_ITENS_PERIODO`,
            setShowModalResumoItens: `@${this.moduloName}/SET_SHOW_MODAL_RESUMO_ITENS`,
            setTabAba: `@${this.moduloName}/SET_TAB_ABA`,
            deleteMov: `@${this.moduloName}/DELETE_MOV`,
            qtItensMovFuncByPeriodo: `@${this.moduloName}/READ_QT_ITENS_MOV_FUNC_BY_PERIODO`
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            setGroupMov: (rows) => action(this.actionsType.setGroupMov, { rows, this: this }),
            setFiltro: (filtro) => action(this.actionsType.setFiltro, { filtro, this: this }),
            setShowMovItem: (showMovItem) => action(this.actionsType.setShowMovItem, { showMovItem, this: this }),
            scriptFecharMovsAbertos: () => action(this.actionsType.fecharMovsAbertos, { this: this }),
            realoadReadView: () => action(this.actionsType.realoadReadView, { this: this }),
            setRowsMovGroup: (rowsGroup) => action(this.actionsType.setRowsMovGroup, { rowsGroup, this: this }),
            newMovVenda: () => action(this.actionsType.newMovVenda, { this: this }),
            createMovimentacao: (mov) => action(this.actionsType.createMovimentacao, { this: this, mov }),
            readMovItensPeriodo: (filtro, aba) => action(this.actionsType.readMovItensPeriodo, { filtro, aba }),
            setShowModalResumoItens: (set) => action(this.actionsType.setShowModalResumoItens, { set }),
            setTabAba: (aba) => action(this.actionsType.setTabAba, { aba }),
            deleteMov: (mov) => action(this.actionsType.deleteMov, { this: this, mov }),
            readQtItensMovFuncByPeriodo: (filtro) => action(this.actionsType.qtItensMovFuncByPeriodo, { filtro, this: this }),


        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.resultAfterEffcts, this.resultAfterMovEffcts),
            takeLatest(this.actionsType.setGroupMov, this.setGroupMovEffects),
            takeLatest(this.actionsType.setFiltro, this.setFiltroEffects),
            takeLatest(this.actionsType.setShowMovItem, this.setShowMovItemEffects),
            takeLatest(this.actionsType.fecharMovsAbertos, this.scriptFecharMovsAbertosEffects),
            takeLatest(this.actionsType.realoadReadView, this.realoadReadViewEffects),
            takeLatest(this.actionsType.setRowsMovGroup, this.setRowsMovGroupEffects),
            takeLatest(this.actionsType.newMovVenda, this.newMovVendaEffects),
            takeLatest(this.actionsType.createMovimentacao, this.createMovimentacaoEffects),
            takeLatest(this.actionsType.readMovItensPeriodo, this.readMovItensPeriodoEffects.bind(this)),
            takeLatest(this.actionsType.setShowModalResumoItens, this.setShowModalResumoItensEffect.bind(this)),
            takeLatest(this.actionsType.setTabAba, this.setTabAbaEffect.bind(this)),
            takeLatest(this.actionsType.deleteMov, this.deleteMovEffect.bind(this)),
            takeLatest(this.actionsType.qtItensMovFuncByPeriodo, this.readQtItensMovFuncByPeriodoEffects.bind(this)),
        ]
    }

    public gerarCodigo = async (): Promise<{ status: "ok" | "error", codigo: string, msg: string }> => {
        try {
            let resp: ResultDb<Movimentacao> = await this.db.getDocID("@CONFIG");
            if (resp.status === "ok") {
                let config = resp.row as Config;
                let codigo_seq = config.seq_cod_mov + 1
                let codigFormat = codigo_seq.toString();
                for (let i = 0; i < (config.qt_dig_cod_mov - codigo_seq.toString().length); i++) {
                    codigFormat = '0' + codigFormat;
                }
                console.log("Gerou os codigos movimentacao", [codigo_seq, codigFormat])
                config.seq_cod_mov = codigo_seq;
                let respUpdaConfig = await this.db.updateData(config);
                if (respUpdaConfig.status === "ok") {
                    return { status: "ok", codigo: codigFormat, msg: "Codigo gerado com sucesso!" };
                } else {
                    return { status: "error", codigo: "", msg: respUpdaConfig.msg }
                }
            } else {
                let msg = "Não foi encontrado a tabela de configuracões, reinicie o aplicativo para o sistema fazer a reparação.";
                return { status: "error", codigo: "", msg: msg }
            }
        } catch (error) {
            let msg = "Ops, ocorreu uma falha em gerarCodigo, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            return { status: "error", codigo: "", msg: "Falha na geração do código da movimentação, detalhes: " + err }
        }
    }

    private * setTabAbaEffect(actions: Payload) {
        let aba = actions.payload.aba as number;
        yield put(this.reducer.resultAfterEffects(
            { ...this.state, tabAba: aba },
            this.actionsType.setTabAba
        ));
    }

    private * createMovimentacaoEffects(actions: Payload) {
        const vm = actions.payload.this as MovController;
        try {
            const mov = actions.payload.mov as Movimentacao;
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: true, msg: `Criando nova ${mov.tipo_mov.descricao}...`, error: false, status: "" },
                vm.actionsType.createMovimentacao
            ))
            if (mov.situacao === "INICIADO")
                mov.situacao = "ABERTO";
            mov.data_situacao = new Date().toISOString();
            //remover o campo enderecos de pessoa
            //mov.pessoa.enderecos = [];
            //Gerar codigo somente se nao for compra
            if (mov.codigo === "" && mov.tipo_mov.descricao !== "COMPRA") {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: true, msg: `Gerando código ${mov.tipo_mov.descricao}...`, error: false, status: "" },
                    vm.actionsType.createMovimentacao
                ))
                let respGerarCodigo: { status: any, codigo: string, msg: string } = yield call(vm.gerarCodigo)
                if (respGerarCodigo.status === "ok") {
                    mov.codigo = respGerarCodigo.codigo;
                    let respSalvar: ResultDb<Movimentacao> = yield call(vm.db.salvar, mov);
                    yield put(vm.reducer.resultAfterEffects(
                        { ...vm.state, loading: false, msg: respSalvar.msg as string, status: "ok", row: respSalvar.row },
                        vm.actionsType.createMovimentacao
                    ))
                } else {
                    yield put(vm.reducer.resultAfterEffects(
                        { ...vm.state, loading: false, msg: respGerarCodigo.msg, status: "error", error: true, showAlert: true },
                        vm.actionsType.createMovimentacao
                    ))
                }
            } else {
                let respSalvar: ResultDb<Movimentacao> = yield call(vm.db.salvar, mov);
                /*
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, msg: "Atualizando estoque..." },
                    vm.actionsType.createMovimentacao
                ))
                let respAtualizaEstoque: ResultDb<Estoque> = yield call(estoqueController.salvarEstoqueAtualizado)
                if (respAtualizaEstoque.status === "ok") {
                    console.log("Estoque atualizado com sucesso após criar movimentação");
                } else {
                    console.log("Erro ao atualizar estoque após criar movimentação", respAtualizaEstoque.msg);
                }*/
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: respSalvar.msg as string, status: "ok", row: respSalvar.row },
                    vm.actionsType.createMovimentacao
                ))
            }

        } catch (error: any) {
            console.log("error resultAfterItemEffcts", error);
            let msg = "Ops, ocorreu uma falha em resultAfterItemEffcts, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.createMovimentacao
            ))
        }
    }

    private * deleteMovEffect(actions: Payload) {
        const vm = actions.payload.this as MovController;
        try {
            //verificar se é compra, se for fazer a estabilizacao do estoque antes de deletar a movimentacao
            const mov = actions.payload.mov as Movimentacao;
            if (mov.tipo_mov.descricao === "COMPRA") {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: true, msg: "Estabilizando estoque antes de deletar a movimentação...", error: false, status: "" },
                    vm.actionsType.deleteMov
                ))
                let respEstabiliza: ResultDb<null> = yield call(estoqueController.estabilizaEstoque, mov.itens);
                if (respEstabiliza.status === "ok") {
                    console.log("Estoque estabilizado com sucesso antes de deletar a movimentação");
                    yield put(vm.reducer.actions.deletar(mov));
                } else {
                    console.log("Erro ao estabilizar estoque antes de deletar a movimentação", respEstabiliza.msg);
                    yield put(vm.reducer.resultAfterEffects(
                        { ...vm.state, loading: false, msg: respEstabiliza.msg as string, status: "error", error: true, showAlert: true },
                        vm.actionsType.deleteMov
                    ))
                }

            } else {
                yield put(vm.reducer.actions.deletar(mov));
            }
        } catch (error: any) {
            console.log("error deleteMovEffect", error);
            let msg = "Ops, ocorreu uma falha em deleteMovEffect, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.deleteMov
            ))
        }
    }

    private * resultAfterMovEffcts(actions: Payload) {
        const vm = actions.payload.this as Controller<Movimentacao, MovState, MovActions>;
        let actionType = actions.payload.actionType;
        try {
            let state: MovState = actions.payload.result;
            if (state.status === "ok") {
                switch (actionType) {
                    case vm.actionsType.create:
                        //gerar o codigo
                        if (state.row.codigo === "") {
                            yield put(configController.reducer.actions.gerarCodigoMov(state.row))
                        }
                        yield put(vm.reducer.actions.setGroupMov(state.rows));
                        break;
                    case vm.actionsType.read:
                        yield put(vm.reducer.actions.setGroupMov(state.rows))
                        break;
                    case vm.actionsType.readView:
                        yield put(vm.reducer.actions.setGroupMov(state.rows))
                        break;
                    case vm.actionsType.update:
                        yield put(vm.reducer.actions.setGroupMov(state.rows))
                        break;
                    case vm.actionsType.deleta:
                        yield put(vm.reducer.actions.setGroupMov(state.rows))
                        break;

                }
            }
        } catch (error: any) {
            console.log("error resultAfterItemEffcts", error);
            let msg = "Ops, ocorreu uma falha em resultAfterItemEffcts, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.resultAfterEffcts
            ))
        }
    }

    /**criar uma nova movimentacao de venda, que verifica se ja tem um canal de distribuicao aberto
     * se nao tiver, cria um novo canal de distribuicao relacrionado com o funcionario logado
     */
    private * newMovVendaEffects(actions: Payload) {
        const self = actions.payload.this as Controller<Movimentacao, MovState, MovActions>;
        try {
            console.log("chamou newMovVendaEffects");
            yield put(self.reducer.resultAfterEffects(
                { ...self.state, loading: true, msg: "Criando nova movimentação de venda..." },
                self.actionsType.newMovVenda
            ));
            //verificar se ja tem canal de distribuicao aberto para o funcionario logado
            const funcLogado = funcionarioController.state.funcLogado;
            //sempre vai existir um funcionario logado para criar a movimentacao, nao precisa validar
            const novaMovVenda = (canalDist: CanalDistribuicao) => {
                console.log("canalDistController.state.canalAberto", canalDist);
                let novaMov: Movimentacao = {
                    ...structuredClone(self.getInitialValue()),
                    created_at: new Date().toISOString(),
                    data_situacao: new Date().toISOString(),
                    pessoa: {
                        _id: configController.state.row.cliente_default._id,
                        nome: configController.state.row.cliente_default.nome,
                        whatsapp: configController.state.row.cliente_default.whatsapp,
                        enderecos: configController.state.row.cliente_default.enderecos,
                        revenda: false
                    },
                    canal_dist: {
                        _id: canalDist._id,
                        data: canalDist.data,
                        funcionario: {
                            _id: canalDist.funcionario._id,
                            nome: canalDist.funcionario.nome,
                            whatsapp: canalDist.funcionario.whatsapp
                        }
                    },
                    tipo_mov: tipoMovController.state.row,
                }
                return novaMov

            }

            if (canalDistController.state.canalAberto._id) {
                //criar a movimentacao de venda com o canal de distribuicao aberto
                let novaMov = novaMovVenda(canalDistController.state.canalAberto);
                yield put(self.reducer.resultAfterEffects(
                    { ...self.state, row: novaMov, msg: "Nova movimentação de venda criada com canal de distribuição aberto.", status: "ok", loading: false, showCadModal: true },
                    self.actionsType.newMovVenda
                ))

            } else {
                //buscar canal de distribuicao para o funcionario logado
                console.log("buscando canal de distribuicao para o funcionario logado", canalDistController);
                let resp: ResultDb<CanalDistribuicao> = yield call(canalDistController.getCanalDistByFuncionario, funcLogado);
                switch (resp.status) {
                    case "ok":
                        console.log("canal de distribuicao encontrado para o funcionario logado", resp.row);
                        yield put(canalDistController.reducer.resultAfterEffects(
                            { ...canalDistController.state, canalAberto: resp.row as CanalDistribuicao, msg: "Canal de distribuição aberto para o funcionário.", status: "ok", loading: false },
                            canalDistController.actionsType.getCanalDistByFuncionarioEffect
                        ))
                        let novaMov = novaMovVenda(resp.row);
                        yield put(self.reducer.resultAfterEffects(
                            { ...self.state, row: novaMov, msg: "Nova movimentação de venda criada com canal de distribuição aberto.", status: "ok", loading: false, showCadModal: true },
                            self.actionsType.newMovVenda
                        ))
                        break;
                    case "not_found":
                        console.log("canal de distribuicao nao encontrado, criando novo canal de distribuicao");
                        let respAdd: ResultDb<CanalDistribuicao> = yield call(canalDistController.addCanalDist, funcLogado);
                        if (respAdd.status === "ok") {
                            console.log("canal de distribuicao criado com sucesso", respAdd.row);
                            yield put(canalDistController.reducer.resultAfterEffects(
                                { ...canalDistController.state, canalAberto: respAdd.row as CanalDistribuicao, msg: "Canal de distribuição criado e aberto para o funcionário.", status: "ok", loading: false },
                                canalDistController.actionsType.addCanalDistEffect
                            ))
                            let novaMov = novaMovVenda(respAdd.row);
                            yield put(self.reducer.resultAfterEffects(
                                { ...self.state, row: novaMov, msg: "Nova movimentação de venda criada com canal de distribuição aberto.", status: "ok", loading: false, showCadModal: true },
                                self.actionsType.newMovVenda
                            ))
                        } else {
                            console.log("erro ao adicionar o canal de distribuicao para o funcionario logado", resp.msg);
                            yield put(self.reducer.resultAfterEffects(
                                { ...self.state, status: "error", loading: false, msg: "Erro ao adicionar o canal de distribuicao para o funcionario. " + respAdd.msg, showAlert: true },
                                self.actionsType.newMovVenda
                            ))
                        }
                        break;
                    case "error":
                        console.log("erro ao buscar o canal de distribuicao para o funcionario logado", resp.msg);
                        yield put(self.reducer.resultAfterEffects(
                            { ...self.state, status: "error", loading: false, msg: "Erro ao buscar o canal de distribuicao para do funcionario. " + resp.msg, showAlert: true },
                            self.actionsType.newMovVenda
                        ))
                        break;
                }
            }
        } catch (error: any) {
            console.log("error newMovVendaEffects", error);
            let msg = "Ops, ocorreu uma falha em newMovVendaEffects, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            yield put(self.reducer.resultAfterEffects(
                { ...self.state, msg: err, status: "error", error: true, showAlert: true },
                self.actionsType.newMovVenda
            ))
        }
    }

    private * setRowsMovGroupEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<Movimentacao, MovState, MovActions>;
        const rowsGroup = actions.payload.rowsGroup;
        console.log("chamou setRowsMovGroupEffects", rowsGroup);
        try {
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, rowGroup: rowsGroup },
                vm.actionsType.setRowsMovGroup
            ));
        } catch (error: any) {
            console.log("error setRowsMovGroupEffects", error);
            let msg = "Ops, ocorreu uma falha em setRowsMovGroupEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.setRowsMovGroup
            ))
        }
    }

    private * scriptFecharMovsAbertosEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<Movimentacao, MovState, MovActions>;
        console.log("chamou scriptFecharMovsAbertos", vm);
        try {
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: true, msg: "Fechando movimentos abertos..." },
                vm.actionsType.scriptFecharMovsAbertos
            ));
            //chamar o script de fechamento de movimentos abertos
            let resp: ResultDb<Movimentacao> = yield call(vm.db.filterView,
                {
                    viewName: "func/mov_pedido_aberto_by_situacao",
                    opt: {},
                    resultViewFull: false
                }

            );
            console.log("resp scriptFecharMovsAbertos", resp);
            let movsFechados: Movimentacao[] = [];
            if (resp && resp.rows && resp.rows.length > 0) {
                //percorrer as movimentações e fechar
                for (let i = 0; i < resp.rows.length; i++) {
                    let mov: Movimentacao = resp.rows[i];
                    console.log("mov a fechar", mov);
                    mov.situacao = "FINALIZADO";
                    mov.data_situacao = new Date().toISOString();
                    movsFechados.push(mov);
                }
                //atualizar as movimentações fechadas
                let respUpdate: ResultDb<Movimentacao> = yield call(vm.db.salveAll, movsFechados);
                console.log("respUpdate scriptFecharMovsAbertos", respUpdate);
                if (respUpdate.status === "ok" && respUpdate.rows && respUpdate.rows.length > 0) {
                    yield put(vm.reducer.resultAfterEffects(
                        { ...vm.state, loading: false, msg: "Movimentos fechados com sucesso!", rows: respUpdate.rows, status: "ok" },
                        vm.actionsType.scriptFecharMovsAbertos
                    ));
                } else {
                    let msg = "Ops, ocorreu uma falha ao fechar os movimentos, detalhes: ";
                    let err = msg + typeof respUpdate === 'object' ? JSON.stringify(respUpdate) : respUpdate
                    yield put(vm.reducer.resultAfterEffects(
                        { ...vm.state, loading: false, msg: err as string, status: "error", error: true, showAlert: true },
                        vm.actionsType.scriptFecharMovsAbertos
                    ))
                }
            } else {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: "Nenhum movimento aberto encontrado para o filtro informado.", status: "ok" },
                    vm.actionsType.scriptFecharMovsAbertos
                ))
            }
        } catch (error: any) {
            console.log("error scriptFecharMovsAbertos", error);
            let msg = "Ops, ocorreu uma falha em scriptFecharMovsAbertos, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.scriptFecharMovsAbertos
            ))
        }
    }



    private * setFiltroEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<Movimentacao, MovState, MovActions>;
        const filtro: FilterMovParams = actions.payload.filtro;
        console.log("chamou setFiltroEffects", filtro);
        try {

            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, filtro: { ...vm.state.filtro, ...filtro } },
                vm.actionsType.setFiltro
            ));

            //recarregar a lista de movimentações
            yield put(vm.reducer.actions.realoadReadView())

        } catch (error: any) {
            console.log("error setFiltroEffects", error);
            let msg = "Ops, ocorreu uma falha em setFiltroEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.setFiltro
            ))
        }
    }

    private * realoadReadViewEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<Movimentacao, MovState, MovActions>;
        const filtro: FilterMovParams = vm.state.filtro;
        console.log("chamou realoadReadViewEffects", filtro);
        try {
            const { tipoMov, dtFim, dtIni } = filtro;
            if (tipoMov) {
                /*let resp: ResultDb<Movimentacao> = yield call(vm.db.filterView, {
                    viewName: "func/mov_by_data_tipo",
                    resultViewFull: false,
                    opt: {
                        include_docs: true,
                        startkey: [tipoMov, dtIni.substr(0, 4), dtIni.substr(5, 2), dtIni.substr(8, 2)],
                        endkey: [tipoMov, dtFim.substr(0, 4), dtFim.substr(5, 2), dtFim.substr(8, 2)]
                    }
                })
                if (resp.status === "ok") {
                    yield put(vm.reducer.resultAfterEffects(
                        {...vm.state,rows:resp.rows as Movimentacao[] },
                        vm.actionsType.realoadReadView
                    ))
                }*/
                yield put(vm.reducer.actions.readView({
                    viewName: "func/mov_by_data_tipo",
                    resultViewFull: false,
                    opt: {
                        include_docs: true,
                        startkey: [tipoMov, dtIni.substr(0, 4), dtIni.substr(5, 2), dtIni.substr(8, 2)],
                        endkey: [tipoMov, dtFim.substr(0, 4), dtFim.substr(5, 2), dtFim.substr(8, 2)]
                    }
                }))

            }


        } catch (error: any) {
            console.log("error realoadReadViewEffects", error);
            let msg = "Ops, ocorreu uma falha em realoadReadViewEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.realoadReadView
            ))
        }
    }

    private * setGroupMovEffects(actions: Payload) {

        const groupMovBySituacao = (rows: Movimentacao[], filtro?: FilterMovParams) => {
            console.log("filtro e rows", [filtro, rows])
            try {
                let rowsGroup: GroupMovimentacaoBySituacao[] = []
                //informar as situacões
                rows.map((row, idx) => {
                    let situacao = row.situacao;
                    let find = rowsGroup.find(rg => rg.situacao === situacao)
                    if (!find) {
                        rowsGroup.push({
                            situacao: situacao,
                            rows: [],
                        })
                    }
                })
                //informa as movimentacoes de acordo com a situacao
                rowsGroup.map(group => {
                    let movsFilter: Movimentacao[] = [];
                    if (filtro && filtro.funcionario && filtro.funcionario._id) {
                        movsFilter = rows.filter(mov => {
                            if (mov.situacao === group.situacao) {
                                if (mov.canal_dist?.funcionario) {
                                    return mov.canal_dist?.funcionario._id === filtro.funcionario?._id
                                }
                            }
                            return false
                        })
                    } else {
                        movsFilter = rows.filter(mov => mov.situacao === group.situacao)
                    }
                    group.rows = movsFilter;
                })
                return { status: "ok", rows: rowsGroup, msg: "Movimentos agrupados com sucesso!" }
            } catch (error) {
                console.log("error groupMovBySituacao", error);
                let err = typeof error === 'object' ? JSON.stringify(error) : error
                return { status: "error", msg: "Ocorreu um erro na função groupMovBySituacao, detalhes: " + err, rows: [] as GroupMovimentacaoBySituacao[] }
            }
        }

        const vm = actions.payload.this as Controller<Movimentacao, MovState, MovActions>;
        const filtro = vm.state.filtro;
        console.log("state setGroupMovEffects", vm)
        try {
            let resp: { status: string, msg: string, rows: GroupMovimentacaoBySituacao[] } = yield call(groupMovBySituacao, actions.payload.rows, filtro)
            if (resp.status === "ok") {
                console.log("resp ok setGroupMovEffects", resp);
                let findeRouGroupBySituacao = resp.rows.find(rg => rg.situacao === vm.state.rowGroup.situacao)
                if (!findeRouGroupBySituacao) {
                    findeRouGroupBySituacao = { situacao: "", rows: [] }
                }
                console.log("findeRouGroupBySituacao", findeRouGroupBySituacao);
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, rowGroup: findeRouGroupBySituacao, rowsGroupBySituacao: [...resp.rows], status: resp.status },
                    vm.actionsType.setGroupMov
                ))
            } else {
                yield put(vm.reducer.resultAfterEffects(
                    { ...vm.state, loading: false, msg: resp.msg, status: "error", error: true, showAlert: true },
                    vm.actionsType.setGroupMov
                ))
            }
        } catch (error: any) {
            let msg = "Ops, ocorreu uma falha em setGroupMovEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            console.log("error em setGroupMovEffects", err);
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.setGroupMov
            ))
        }
    }

    private * setShowMovItemEffects(actions: Payload) {
        const vm = actions.payload.this as Controller<Movimentacao, MovState, MovActions>;
        const showMovItem = actions.payload.showMovItem;
        console.log("chamou setShowMovItemEffects", showMovItem);
        try {
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, showMovItem },
                vm.actionsType.setShowMovItem
            ));
        } catch (error: any) {
            console.log("error setShowMovItemEffects", error);
            let msg = "Ops, ocorreu uma falha em setShowMovItemEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(vm.reducer.resultAfterEffects(
                { ...vm.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                vm.actionsType.setShowMovItem
            ))
        }
    }

    private * readMovItensPeriodoEffects(actions: Payload) {
        try {
            console.log("chamou readMovItensPeriodoEffects")
            let filtro: FiltroReadMovCanal = actions.payload.filtro;
            let aba: string = actions.payload.aba;
            if (filtro.dtFim && filtro.dtIni) {
                const { dtIni, dtFim } = filtro
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, msg: "Buscando movimentacões por itens...", status: "", rows_itens_mov_detalhe: { ...this.state.rows_itens_mov_detalhe, loading: true }, showModalResumoItens: true },
                    this.actionsType.readMovItensPeriodo
                ))

                let viewName = "";
                switch (aba) {
                    case "venda-pedidos":
                        viewName = "func/itens_mov_resumo_by_data_item";
                        break;
                    case "compras":
                        viewName = "func/itens_mov_compra_by_data_item";
                        break;
                    case "avaria":
                        viewName = "func/itens_mov_avaria_by_data_item";
                        break;
                    case "estoque":
                        viewName = "func/itens_mov_resumo_by_data_item_estoque";
                        break;
                }
                let resp: ResultDb<any> = yield call(this.db.filterView, {
                    viewName: viewName,
                    opt: {
                        startkey: [dtIni.substr(0, 4), dtIni.substr(5, 2), dtIni.substr(8, 2)],
                        endkey: [dtFim.substr(0, 4), dtFim.substr(5, 2), dtFim.substr(8, 2), {}],
                        group_level: 4,
                    },
                    resultViewFull: true
                })
                console.log("resp readMovItensPeriodoEffects", resp);
                if (resp.status === "ok") {
                    if (resp.rows && resp.rows.length > 0) {
                        let dados: RowItensMovDetalhe = {
                            coluna: ["Data"],
                            values: [],
                            total: [],
                            loading: false
                        };
                        //fazer um loop para montar as colunas
                        resp.rows.map((row, idx) => {
                            let coluna = row.key[3];//descricao do item esta na posicao de key de 0 a 3 = 3 de acordo a view itens_mov_resumo_by_data_item
                            //verificar se a coluna com a descricao do item ja exite
                            let findColuna = dados.coluna.find(desc => desc === coluna)
                            if (!findColuna) {
                                dados.coluna.push(coluna)
                            }
                        })

                        //fazer um loop para inserir os valores de data 
                        resp.rows.map((row, idx) => {
                            let data = `${row.key[2]}/${row.key[1]}/${row.key[0]}`;//data na posicao de key da view 0 = ano 1 = mes 2 = dia
                            let colunaDaVez = row.key[3];
                            //verificar se ja tem a data inserida
                            let findData = dados.values.find(value => value["Data"] === data);
                            if (!findData) {
                                //inserir as propriedades com o nome das colunas
                                let propsValue: any = { _id: idx }
                                dados.coluna.map(coluna => {
                                    if (coluna === "Data") {//se for data, ja coloca a data
                                        propsValue[coluna] = data;
                                        //se for data, é pq ainda nao tem registros em dados.values
                                        //entao inserir
                                        dados.values.push(propsValue);
                                    } else {//se nao, sera a descricao do item
                                        if (coluna === colunaDaVez) {//verifica se a coluna do loop é igual a coluna atual do map principal, se for ja coloca o valor, se nao deixa zerado
                                            propsValue[coluna] = {
                                                qt: row.value[0],
                                                total: row.value[1],
                                            }
                                        } else {//nao é igual deixa zerado
                                            propsValue[coluna] = {
                                                qt: 0,
                                                total: 0,
                                            }
                                        }
                                        //localizar o registro em data.values para adicionar a propriedade
                                        let findValue = dados.values.find(v => v["Data"] === data);
                                        findValue = propsValue
                                    }

                                })
                            } else {//se encontrar a data é porque ja tem informaçoes da coluna
                                findData[colunaDaVez] = {
                                    qt: row.value[0],
                                    total: row.value[1],
                                }
                            }
                        })


                        let totalizacao: any[] = [];
                        dados.coluna.map(value => {
                            if (value !== "Data") {
                                let qt = 0;
                                let total = 0;
                                resp.rows?.map(row => {
                                    if (row.key[3] === value) {
                                        qt = qt + row.value[0];
                                        total = total + row.value[1]
                                    }
                                })
                                let obj = {
                                    item: value,
                                    qt: qt,
                                    total: total
                                }
                                totalizacao.push(obj);
                            }
                        })
                        dados.total = totalizacao;

                        console.log("dados pivotado readMovItensPeriodoEffects", dados);

                        switch (aba) {
                            case "venda-pedidos":
                                yield put(this.reducer.resultAfterEffects(
                                    { ...this.state, msg: "", status: "ok", rows_itens_mov_detalhe: dados },
                                    this.actionsType.readMovItensPeriodo
                                ))
                                break;
                            case "compras":
                                yield put(this.reducer.resultAfterEffects(
                                    { ...this.state, msg: "", status: "ok", rows_itens_compras_detalhe: dados },
                                    this.actionsType.readMovItensPeriodo
                                ))
                                break;
                            case "avaria":
                                yield put(this.reducer.resultAfterEffects(
                                    { ...this.state, msg: "", status: "ok", rows_itens_avaria_detalhe: dados },
                                    this.actionsType.readMovItensPeriodo
                                ))
                                break;
                            case "estoque":
                                yield put(this.reducer.resultAfterEffects(
                                    { ...this.state, msg: "", status: "ok", rows_itens_estoque_detalhe: dados },
                                    this.actionsType.readMovItensPeriodo
                                ))
                                break;
                        }


                    } else {
                        yield put(this.reducer.resultAfterEffects(
                            { ...this.state, rows_itens_mov_detalhe: { ...this.state.rows_itens_mov_detalhe, loading: false }, msg: "", status: "ok", },
                            this.actionsType.readMovItensPeriodo
                        ))
                    }

                } else {
                    yield put(this.reducer.resultAfterEffects(
                        { ...this.state, rows_itens_mov_detalhe: { ...this.state.rows_itens_mov_detalhe, loading: false }, msg: resp.msg as string, status: "error", error: true, showAlert: true },
                        this.actionsType.readMovItensPeriodo
                    ))
                }
            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, rows_itens_mov_detalhe: { ...this.state.rows_itens_mov_detalhe, loading: false }, msg: "Periodo não foi definido.", status: "error", error: true, showAlert: true },
                    this.actionsType.readMovItensPeriodo
                ))

            }

        } catch (error: any) {
            console.log("error readMovItensPeriodo", error);
            let msg = "Ops, ocorreu uma falha em readMovItensPeriodo, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, rows_itens_mov_detalhe: { ...this.state.rows_itens_mov_detalhe, loading: false }, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.readMovItensPeriodo
            ))
        }
    }

    private * setShowModalResumoItensEffect(actions: Payload) {
        yield put(this.reducer.resultAfterEffects(
            { ...this.state, showModalResumoItens: actions.payload.set },
            this.actionsType.setShowModalResumoItens
        ))
    }

    private * readQtItensMovFuncByPeriodoEffects(actions: Payload) {
        yield put(this.reducer.resultAfterEffects(
            { ...this.state, msg: "Buscando quantidade de itens movimentados por funcionario no periodo...", status: "", loadingRows: true },
            this.actionsType.readQtItensMovFuncByPeriodo
        ))
        let filtro: FiltroReadMovCanal = actions.payload.filtro;
        let resp: ResultDb<RowItensMovDetalheFunc> = yield call(this.readQtItensMovFuncByPeriodo, filtro)
        if (resp.status === "ok") {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, msg: "", status: "ok", rows_itens_mov_qt_funcionario: resp.rows as RowItensMovDetalheFunc[], loadingRows: false },
                this.actionsType.readQtItensMovFuncByPeriodo
            ))
        } else {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, msg: resp.msg as string, status: "error", error: true, showAlert: true, loadingRows: false },
                this.actionsType.readQtItensMovFuncByPeriodo
            ))
        }
    }

    readQtItensMovFuncByPeriodo = async (filtro: FiltroReadMovCanal): Promise<ResultDb<RowItensMovDetalheFunc>> => {
        try {
            if (filtro.dtFim && filtro.dtIni) {
                let resp: ResultDb<any> = await this.db.filterView({
                    viewName: "func/qt_mov_itens_by_data_funcionario",
                    opt: {
                        startkey: [filtro.dtIni.substr(0, 4), filtro.dtIni.substr(5, 2), filtro.dtIni.substr(8, 2)],
                        endkey: [filtro.dtFim.substr(0, 4), filtro.dtFim.substr(5, 2), filtro.dtFim.substr(8, 2), {}],
                        group_level: 5,
                    },
                    resultViewFull: true
                });
                console.log("resp view readQtItensMovFuncByPeriodo", resp)
                if (resp.status === "ok") {
                    let dados: RowItensMovDetalheFunc[] = [];
                    //buscar os funcionarios para preencher os dados
                    let respFunc = await funcionarioController.read({
                        fieldsFilter: [
                            { fieldName: "ativo", fieldValue: true, mangoQuery: "$eq" }
                        ],
                        indexName: "idx_funcionarios_ativo"
                    }) as ResultDb<Funcionario>;
                    if (respFunc.status === "ok" && respFunc.rows) {
                        //preencher os dados com os funcionarios
                        respFunc.rows.map((row: Funcionario, idx: number) => {
                            let value: RowItensMovDetalheFunc = {
                                _id: row._id,
                                funcionario: row.nome,
                                rows: {
                                    coluna: ["Data"],
                                    values: [],
                                    total: [],
                                    loading: false
                                }
                            }
                            dados.push(value);
                        })

                        //buscar os itens cadastrados para preencher as colunas
                        let respItens = await itemController.read() as ResultDb<Item>;
                        if (respItens.status === "ok" && respItens.rows as Item[]) {

                            //fazer um loop nos dados para preencher as colunas dos itens vinculado ao funcionario
                            dados.map((dado) => {
                                //filtrar os itens do funcionario para preencher os valores
                                let itensFunc = resp.rows?.filter((row) => row.key[4] === dado._id)
                                if (itensFunc && itensFunc.length > 0) {

                                    //fazer o loop para monta a coluna
                                    itensFunc.map((row, idx) => {
                                        let findDescItemColuna = respItens.rows?.find((item: Item) => item._id === row.key[3])
                                        if (findDescItemColuna) {
                                            let findColuna = dado.rows.coluna.find(value => value === findDescItemColuna.descricao)
                                            if (!findColuna) {
                                                dado.rows.coluna.push(findDescItemColuna.descricao)
                                            }
                                        } else {
                                            console.log("Item não encontrado para o id", row.key[3]);
                                        }
                                    })


                                    itensFunc.map((row, idx) => {
                                        let data = `${row.key[2]}/${row.key[1]}/${row.key[0]}`;//data na posicao de key da view 0 = ano 1 = mes 2 = dia
                                        let colunaDaVez = respItens.rows?.find((item: Item) => item._id === row.key[3]) as Item
                                        if (colunaDaVez) {
                                            var totalizacao: { qt: number, comissao: number, item: string } = { qt: 0, comissao: 0, item: "" }

                                            //verificar se ja tem a data inserida
                                            let findData = dado.rows.values.find(value => value["Data"] === data);
                                            if (!findData) {
                                                //inserir as propriedades com o nome das colunas
                                                let propsValue: any = { _id: idx }
                                                dado.rows.coluna.map(coluna => {
                                                    if (coluna === "Data") {//se for data, ja coloca a data
                                                        propsValue[coluna] = data;
                                                        //se for data, é pq ainda nao tem registros em dados.values
                                                        //entao inserir
                                                        dado.rows.values.push(propsValue);
                                                    } else {//se nao, sera a descricao do item
                                                        if (coluna === colunaDaVez.descricao) {//verifica se a coluna do loop é igual a coluna atual do map principal, se for ja coloca o valor, se nao deixa zerado
                                                            propsValue[coluna] = row.value
                                                            totalizacao.qt = totalizacao.qt + row.value;
                                                            let comissaoItem = colunaDaVez.comissao ? colunaDaVez.comissao : 0;
                                                            totalizacao.comissao = totalizacao.comissao + (row.value * comissaoItem);
                                                            totalizacao.item = colunaDaVez.descricao;

                                                        } else {//nao é igual deixa zerado
                                                            propsValue[coluna] = 0
                                                        }
                                                        //localizar o registro em data.values para adicionar a propriedade
                                                        let findValue = dado.rows.values.find(v => v["Data"] === data);
                                                        findValue = propsValue
                                                    }

                                                })
                                            } else {//se encontrar a data é porque ja tem informaçoes da coluna
                                                findData[colunaDaVez.descricao] = row.value
                                                totalizacao.qt = totalizacao.qt + row.value;
                                                let comissaoItem = colunaDaVez.comissao ? colunaDaVez.comissao : 0;
                                                totalizacao.comissao = totalizacao.comissao + (row.value * comissaoItem);
                                                totalizacao.item = colunaDaVez.descricao;
                                            }
                                            //antes de adcionar ao total, verificar se ja tem o item na totalizacao, se tiver, somar a quantidade e comissao, se nao, adicionar
                                            let findItemTotalizacao = dado.rows.total.find(t => t.item === totalizacao.item);
                                            if (findItemTotalizacao) {
                                                findItemTotalizacao.qt = findItemTotalizacao.qt + totalizacao.qt;
                                                findItemTotalizacao.comissao = findItemTotalizacao.comissao + totalizacao.comissao;
                                            } else {
                                                dado.rows.total.push(totalizacao)
                                            }
                                        } else {
                                            console.log("Item não encontrado para o id", row.key[3]);
                                        }
                                    })

                                }


                            })
                            console.log("dados pivotado readQtItensMovFuncByPeriodo", dados);

                            return { status: "ok", rows: dados }
                        } else {
                            return { status: "error", msg: respItens.msg }
                        }
                    } else {
                        return { status: "error", msg: "Erro ao buscar os funcionarios para preencher os dados, detalhes: " + respFunc.msg, rows: [] as RowItensMovDetalheFunc[] }
                    }
                } else {
                    return { status: "error", msg: resp.msg, rows: [] as RowItensMovDetalheFunc[] }
                }
            } else {
                return { status: "error", msg: "Periodo não foi definido.", rows: [] as RowItensMovDetalheFunc[] }
            }
        } catch (error: any) {
            let msg = "Ops, ocorreu uma falha em readQtItensMovFuncByPeriodo, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            return { status: "error", msg: err, rows: [] as RowItensMovDetalheFunc[] }
        }
    }


}

export const movController = new MovController()

export const mapStateToMovProps = (state: ApplicationState) => ({
    movState: state.movState,
    tipoMovState: state.tipoMovState
})

export const mapDispatchToMovProps = (dispatch: Dispatch) => ({
    movActions: bindActionCreators({ ...movController.reducer.actions }, dispatch),
    meioPagActions: bindActionCreators({ ...meioPagController.reducer.actions }, dispatch),
    clienteActions: bindActionCreators({ ...clienteController.reducer.actions }, dispatch),
    funcionarioActions: bindActionCreators({ ...funcionarioController.reducer.actions }, dispatch),
    fornecedorActions: bindActionCreators({ ...fornecedorController.reducer.actions }, dispatch),
    itemActions: bindActionCreators({ ...itemController.reducer.actions }, dispatch),
})